import { Checkbox } from "@/components/ui/checkbox/Checkbox";
import { Label } from "@/components/ui/label/Label";

export const BORROWING_RESPONSIBILITY_TEXT =
  "Dengan menyetujui dan mengirimkan formulir peminjaman ini, saya memahami serta menyetujui bahwa barang/alat yang dipinjam menjadi tanggung jawab saya selama masa peminjaman, dan saya bersedia bertanggung jawab penuh atas segala kerusakan, kehilangan, atau kondisi yang timbul akibat penggunaan barang/alat tersebut.";

type Props = {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
};

const BorrowingResponsibilityConfirmation = ({
  checked,
  onCheckedChange,
  className = "",
}: Props) => {
  return (
    <div className={`w-full rounded-md border border-input p-4 ${className}`}>
      <div className="flex items-start space-x-3">
        <Checkbox
          id="borrowing-responsibility-confirmation"
          checked={checked}
          onCheckedChange={(value) => onCheckedChange(value === true)}
        />
        <Label
          htmlFor="borrowing-responsibility-confirmation"
          className="text-sm leading-6 cursor-pointer"
        >
          {BORROWING_RESPONSIBILITY_TEXT}
        </Label>
      </div>
    </div>
  );
};

export default BorrowingResponsibilityConfirmation;
